module.exports = __webpack_public_path__ + "img/01n@2x.644849c6.svg";